async function devtricker_perform_postLikeToggleOnClick() {

    let userId = devtricker_getTheLoggedUserId();

    if (!userId) {
        devtricker_openSocialLoginModal();
        return;
    }

    let postId = devtricker_getThePostId();

    let liked = devtricker_session_post_like_isPostLiked(postId);

    try {

        if (!liked) {
            devtricker_dom_setchangeLikeIconToFilledAnnimated();

            devtricker_session_post_like_savePostInLikedPosts(postId);

            await devtricker_ajax_toggleLikePost(postId);

        } else {
            devtricker_dom_setchangeLikeIconToOriginal();
            devtricker_session_post_like_deletePostFromLikedPosts(postId);

            //TODO: Refactor this
            await devtricker_ajax_toggleLikePost(postId);
        }
    } catch (error) {

        devtricker_log(error, devtricker_log_level.ERROR, 'Unable to toogle like post');
    }
}

async function devtricker_perform_setLikenIconFill() {

    let userId = devtricker_getTheUserId();

    if (!userId) {
        return;
    }

    let postId = devtricker_getThePostId();

    if (!postId) {
        return;
    }

    let liked = devtricker_session_post_like_isPostLiked(postId);

    if (liked) {
        devtricker_dom_set_changeLikeIconTofilled();
    }
}

async function devtricker_perform_getLikeAction(postId) {

    let userId = devtricker_getTheUserId();

    if (!userId) {
        return;
    }

    let isInDatabase = devtricker_session_post_like_isPostLiked(postId);

    if (!isInDatabase) {
        return 'UNLIKE'
    } else {
        return 'LIKE'
    }
}